import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./navbar/Header";
import Footer from "./Footer";

const About = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = localStorage.getItem("user");
    if (auth) {
      navigate("/dashboard");
    }
  }, [navigate]);

  return (
    <>
      <Header />

      {/* Embedded CSS */}
      <style>{`
        .about-container {
          padding: 60px 20px;
          background-color: #f3f3f3;
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 70vh;
        }

        .about-content {
          max-width: 900px;
          text-align: center;
        }

        .about-content h1 {
          font-size: 3rem;
          margin-bottom: 20px;
          color: #d90429;
          font-weight: bold;
        }

        .about-content p {
          font-size: 1.1rem;
          color: #333;
          line-height: 1.8;
        }

        .about-content a {
          color: #d90429;
          text-decoration: none;
          font-weight: 600;
        }

        .about-content a:hover {
          text-decoration: underline;
        }

        @media (max-width: 768px) {
          .about-content h1 {
            font-size: 2.2rem;
          }

          .about-content p {
            font-size: 1rem;
          }
        }
      `}</style>

      {/* About Section */}
      <div className="about-container">
        <div className="about-content">
          <h1>About PicAura</h1>
          <p>
            <strong>PicAura</strong> by <strong>Three Musketeers Infotech</strong> is an innovative platform built specifically for event photographers. <br /><br />
            PicAura is an intelligent event photography platform designed for studios with multiple photographers. Built to streamline the photo-sharing experience, PicAura empowers studio admins to manage events and assign photographers with ease. Photographers upload event photos directly to the platform, while guests can access their photos instantly by scanning a unique QR code provided at the event. Without the need for registration, guests simply scan, upload a selfie, and view only the photos they appear in—thanks to our advanced facial recognition system. PicAura offers a seamless, secure, and personalized photo experience for every celebration.
            <br /><br />
            Fast. Private. Magical. 🎉
            <br /><br />
            For partnership or support, contact us at: <br />
            📧 <a href="mailto:info@3mi.info">info@3mi.info</a> <br />
            📞 <a href="tel:+919422538012">+91 94225 38012</a>
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default About;
